import React, { useState, useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { RestAPI } from "@aws-amplify/api-rest";
import LoadingDialog from "../Utils/LoadingDialog";
import SelfHelp from "../Utils/SelfHelp";
import withName from "../../hoc/withName";
import { useNavigate } from "react-router";

import { FilterMatchMode } from "primereact/api";
import DataTablePrime from "../PrimeComponents/DataTablePrime";

const BillingClientParams = () => {

    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState(null);
    const selfHelpDescarga = [{
        tab: 1, header: { text: t("selfHelp.instructions") }, params:[]
    }];
    const names = useMemo(() => [
        t("billing.clientParamsPage.table.account"),
        t("billing.clientParamsPage.table.farm"),
        t("billing.clientParamsPage.table.ncliente"),
    ], [t]);
    useEffect(() => {
        if (data===null) {
            RestAPI.get("apiAdminDropControl","/billing/clientparams",{}).then(async (response) => {
                setData(response);
                setIsLoading(false);
            })
                .catch((error) => {
                    setIsLoading(false);
                    console.log(error);
                });
        }
    },[data,t]);


    const nClientTemplate = (rowData) =>{
        return <a href="#" onClick={(e) => {navigate({ pathname: `/billing/clientparams/${rowData.n_cliente_id}` });}} >{rowData.n_cliente_id}</a>;
    };
    return (
        isLoading?<LoadingDialog />
            :<div className='row-container'>
                <div className='row'>
                    <div className="col-xl-12 col-lg-12 col-sm-12">
                        <div id="cardRaw" className="card">
                            <div className="card-body">
                                <div className='row'>
                                    <div className='col col-sm-2 col-md-3 col-lg-3'>
                                        {false && selfHelpDescarga &&
                                        <SelfHelp t={t} lng={i18n.language} params={selfHelpDescarga} fertiTable />}
                                    </div>
                                    <div className='col col-sm-10 col-md-8 col-lg-6 text-center'>
                                        <h5 className="card-title"><span>{t("billing.sideBar.clientParams")}</span></h5>
                                    </div>
                                    <div className='col col-sm-3 col-md-3 col-lg-3 d-flex justify-content-end align-items-right align-items-center' />
                                    <div className="col-12 text-center">
                                        <div className="row linea-formulario">
                                            <DataTablePrime
                                                t={t}
                                                header="search"
                                                items={data}
                                                scrollHeight="55vh"
                                                paginator rows={10} rowsPerPageOptions={[10, 25, 50]}
                                                filters={{
                                                    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                                                    n_cliente_id: { value: null, matchMode: FilterMatchMode.EQUALS },
                                                    razon_social: { value: null, matchMode: FilterMatchMode.CONTAINS },
                                                    nombre: { value: null, matchMode: FilterMatchMode.CONTAINS },
                                                }}
                                                size="small"
                                                globalFilterFields={["razon_social", "nombre", "n_cliente_id"]}
                                                fields={[
                                                    {field:"razon_social",header:names[0], bodyStyle:{textAlign:"center"}},
                                                    {field:"nombre",header:names[1], bodyStyle:{textAlign:"center"}},
                                                    {field:"n_cliente_id",header:names[2], body:nClientTemplate, bodyStyle:{textAlign:"center"}},
                                                ]}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default withName(BillingClientParams, "BillingClientParams");
